import React from 'react';
import './classes/ApprenticeshipPrograms.css';
import { configData } from "../config";

// The live site's "Apprenticeship Programs" block (Drupal custom block 70): the Basketball
// Apprenticeship banner, linked, under the conferences placed on the Basketball Analytics course page
const ApprenticeshipPrograms = () => (
    <div id="block-block-70" className="conference-section apprenticeship-programs">
        <h2>Apprenticeship Programs</h2>
        <div className="apprenticeship-programs__content">
            <p>
                <a href="/basketball_apprenticeship">
                    <img src={configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/default/files/apprenticeship_basketball_banner.png'} alt="Basketball Apprenticeship" loading="lazy" />
                </a>
            </p>
        </div>
    </div>
);

export default ApprenticeshipPrograms;
